<crm-single-select
  #singleSelectComponent
  [options]="storages"
  [(selectedItem)]="_selectedStorage"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Хранилище S3' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [virtualScroll]="true"
  [virtualScrollItemSize]="35"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  itemDescriptionField="number"
  [showClear]="showClear"
  filterBy="name,number">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
